import { render, staticRenderFns } from "./featured.vue?vue&type=template&id=7cd8b6f4&scoped=true"
import script from "./featured.vue?vue&type=script&lang=js"
export * from "./featured.vue?vue&type=script&lang=js"
import style0 from "./featured.vue?vue&type=style&index=0&id=7cd8b6f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd8b6f4",
  null
  
)

export default component.exports